import * as React from "react";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Stack from "@mui/material/Stack";
import axios from "axios";
import { errorToast, successToast } from "../../common/ToastMessage";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

function BootstrapDialogTitle(props) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

export default function VendorsDeleteModal({ vendoresId, open, close, getvendor, setLoaderActive }) {

  function deleteVendorsData() {
    setLoaderActive(true)
    const headers = {
      Authorization: "Bearer " + localStorage.getItem("_token"),
      "Content-type": "application/json",
    };
    axios
      .post(
        `${process.env.REACT_APP_API_ENDPOINT_PROD}/Api/Vendor/MultipleDelete`,
        vendoresId,
        {
          headers: headers,
        }
      )
      .then(function (response) {
        if (response?.status == "200") {
          close();
          successToast(response?.data?.message)
          getvendor();
        }
      })
      .catch(function (error) {
        console.log("error -", error);
        setLoaderActive(false)
        if (error?.response?.status === 401) {
          errorToast(error?.response?.statusText)
        } else {
          errorToast(error?.message)
        }
      });
  }

  return (
    <div>
      {open ? (
        <BootstrapDialog
          className="delete-modal-wrap"
          onClose={() => close()}
          aria-labelledby="customized-dialog-title"
          open={open}
        >
          <BootstrapDialogTitle
            id="customized-dialog-title"
            onClose={() => close()}
          >
            Are you sure you want to delete?
          </BootstrapDialogTitle>

          <DialogActions className="btns-wrapper">
            <Stack spacing={4} direction="row" className="bottom-btn-wrap">
              <Button onClick={deleteVendorsData} variant="contained" style={{ backgroundColor: '#002138', borderRadius: '30px',width:'100px' }}>
                Yes
              </Button>
              <Button
                variant="contained" style={{ backgroundColor: '#002138', borderRadius: '30px' ,width:'100px'}}
                onClick={() => {
                  close();
                }}
              >
                Cancel
              </Button>
            </Stack>
          </DialogActions>
        </BootstrapDialog>
      ) : null}
    </div>
  );
}
